
import { Field } from 'react-final-form';
import Wizard from './Wizard'
import { signUpUpdateProfile, login } from '../../actions'
import { connect } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { useState } from 'react';
const SignUpPageThree = ({ signUpstate, signUpUpdateProfile, closeModel, successPath, payButton }) => {
    const history = useHistory()
    const [loading, setLoading] = useState(false)
    const [formError, setFormError] = useState({status: null, msg: 'null'})
    const onSubmit = (formValues) => {
        setLoading(true)
        formValues.password = signUpstate.password
        signUpUpdateProfile(formValues, signUpstate.number, closeModel, setLoading, setFormError, history, successPath, payButton)
        
    }
    const validateField = value => (value ? undefined : "Required")
    return (

            <Wizard initialValues={{}} onSubmit={onSubmit} loading={loading} formError={formError}>
                    <Wizard.Page>
                        <div className="two fields">
                            <Field name="first_name" validate={validateField}>
                                {({ input, meta }) => (
                                    <div className={`field ${meta.touched && meta.error && "error"}`}>
                                        <label>First Name</label>
                                        <input type="text" {...input} placeholder="First name"/>
                                    </div>
                                )}
                            </Field>
                            <Field name="last_name" validate={validateField}>
                                {({ input, meta }) => (
                                    <div className={`field ${meta.touched && meta.error && "error"}`}>
                                        <label>Last Name</label>
                                        <input type="text" {...input} placeholder="Last name"/>
                                    </div>
                                )}
                            </Field>
                        </div>
                        <Field name="email" validate={validateField}>
                            {({ input, meta }) => (
                                <div className={`field ${meta.touched && meta.error && "error"}`}>
                                <label>Email</label>
                                <input type="email" {...input} placeholder="Email"/>
                                </div>
                            )}
                        </Field>  
                        <Field name="state" validate={validateField}>
                            {({ input, meta }) => (
                                <div className={`field ${meta.touched && meta.error && "error"}`}>
                                <label>State</label>
                                <input type="text" {...input} placeholder="State"/>
                                </div>
                            )}
                        </Field>   
                    </Wizard.Page>
                    <Wizard.Page>
                        <Field name="address_1" validate={validateField}>
                            {({ input, meta }) => (
                                <div className={`field ${meta.touched && meta.error && "error"}`}>
                                <label>Address 1</label>
                                <input type="text" {...input} placeholder="Address One"/>
                                </div>
                            )}
                        </Field>   
                        <Field name="address_2" validate={validateField}>
                            {({ input, meta }) => (
                                <div className={`field ${meta.touched && meta.error && "error"}`}>
                                <label>Address 2</label>
                                <input type="text" {...input} placeholder="Address Two"/>
                                </div>
                            )}
                        </Field>
                        <div className="two fields">
                            <Field name="city" validate={validateField}>
                                {({ input, meta }) => (
                                    <div className={`field ${meta.touched && meta.error && "error"}`}>
                                        <label>City</label>
                                        <input type="text" {...input} placeholder="City"/>
                                    </div>
                                )}
                            </Field>
                            <Field name="pincode" validate={validateField}>
                                {({ input, meta }) => (
                                    <div className={`field ${meta.touched && meta.error && "error"}`}>
                                        <label>Pincode</label>
                                        <input type="text" {...input} placeholder="Pincode"/>
                                    </div>
                                )}
                            </Field>
                        </div>
                    </Wizard.Page>
                </Wizard>
    )
}
export default connect(null, { signUpUpdateProfile, login })(SignUpPageThree)